import { FC, useEffect, useState } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useQuery, useMutation } from 'react-query';
import { Grid, Card, CardContent, Typography, Button, Container, Paper } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import GoogleSvg from '../../../assets/googlelogo.svg';
import ZoomSvg from '../../../assets/zoom-logo.png';
import MicrosoftSvg from '../../../assets/microsoft.png';
import GithubSvg from '../../../assets/GitHub-logo.png';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useHistory } from 'react-router-dom';
import { Provider } from './types';
import { handleCompanyUrl } from 'utils/organizationUtils';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import { Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, FormControlLabel } from '@material-ui/core';
import axios from 'server';
export const AppsTable: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const {
    AppStore: { googleDisconnected, appConnect, appReConnect },
    dashboardStore: { getAppStatistic },
    ldapStore: { getUser },
    notificationStore: { openNotification },
  } = useStore();
  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const permission = profile?.permission;
  const [googleId, setGoogleId] = useState(null);
  const [zoomId, setZoomId] = useState(null);
  const [microsoftId, setmicrosoftId] = useState(null);
  const [githubId, setgithubId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedApps, setSelectedApps] = useState<string[]>([]);
  const getUsersReq = useQuery('getUsersReq', () => getUser(profile.id), {
    onError: () => openNotification('error', `Can't get users`),
    enabled: profile?.permission === 'EndUser' || profile?.permission === 'Manager',
  });

  const getAppStatisticReq = useQuery('getAppStatisticReq', () => getAppStatistic(), {
    onError: () => openNotification('error', `Can't get statistic`),
    enabled: profile?.permission !== 'EndUser' && profile?.permission !== 'Manager',
  });
  const appStatistics = getAppStatisticReq?.data?.data?.totals;

  useEffect(() => {
    if (getUsersReq.data && getUsersReq.data.length > 0) {
      setGoogleId(getUsersReq.data[0].googleId);
      setZoomId(getUsersReq.data[0].zoomId);
      setmicrosoftId(getUsersReq.data[0].microsoftId);
      setgithubId(getUsersReq.data[0].githubId);
    } else {
      setGoogleId(null);
      setZoomId(null);
      setmicrosoftId(null);
      setgithubId(null);
    }
  }, [getUsersReq]);

  const useAppConnectReq = useQuery('useAppConnectReq', () => appConnect(), {
    onError: () => openNotification('error', `Can't get apps`),
    enabled: profile?.permission !== 'EndUser' && profile?.permission !== 'Manager',
  });
  const [googleConnected, setgoogleConnected] = useState<Provider | null>(null);
  const [zoomConnected, setzoomConnected] = useState<Provider | null>(null);
  const [microsoftConnected, setmicrosoftConnected] = useState<Provider | null>(null);
  const [githubConnected, setgithubConnected] = useState<Provider | null>(null);
  useEffect(() => {
    if (useAppConnectReq?.data) {
      useAppConnectReq.data.forEach((item: Provider) => {
        if (item.provider === 'google') {
          setgoogleConnected(item);
        }
        if (item.provider === 'zoom') {
          setzoomConnected(item);
        }
        if (item.provider === 'microsoft') {
          setmicrosoftConnected(item);
        }
        if (item.provider === 'github') {
          setgithubConnected(item);
        }
      });
    }
  }, [useAppConnectReq]);

  const useAppDisconnected = (provider: string) => {
    return useMutation(() => googleDisconnected(provider), {
      onSuccess: (data) => {
        openNotification('success', `Disconnected from ${provider}`);
        const googleUrl = googleConnected?.connectUrl ?? '';
        const zoomUrl = zoomConnected?.connectUrl ?? '';
        const microsoftUrl = microsoftConnected?.connectUrl ?? '';
        if (provider === 'google' && googleUrl) {
          window.location.href = googleUrl;
        } else if (provider === 'zoom' && zoomUrl) {
          window.location.href = zoomUrl;
        } else if (provider === 'microsoft' && microsoftUrl) {
          window.location.href = microsoftUrl;
        } else {
          console.log('No redirect URL found for:', provider);
        }
      },
      onError: (error) => {
        openNotification(
          'error',
          `We are unable to disconnect from ${provider.charAt(0).toUpperCase() + provider.slice(1)}`
        );
      },
    });
  };

  const useReconnected = (provider: string) => {
    return useMutation(() => appReConnect(provider), {
      onSuccess: () => {
        openNotification('success', `Reconnected from ${provider}`);
      },
      onError: () =>
        openNotification(
          'error',
          `We are unable to reconnect from ${provider.charAt(0).toUpperCase() + provider.slice(1)}`
        ),
    });
  };
  const googleReconnectedReq = useReconnected('google');
  const zoomReconnectedReq = useReconnected('zoom');
  const microsoftReconnectedReq = useReconnected('microsoft');
  const githubReconnectedReq = useReconnected('github');
  const googleDisconnectedReq = useAppDisconnected('google');
  const zoomDisconnectedReq = useAppDisconnected('zoom');
  const microsoftDisconnectedReq = useAppDisconnected('microsoft');
  const githubDisconnectedReq = useAppDisconnected('github');
  const handleConnectClick = (provider: string) => {
    const googleUrl = googleConnected?.connectUrl ?? '';
    const zoomUrl = zoomConnected?.connectUrl ?? '';
    const microsoftUrl = microsoftConnected?.connectUrl ?? '';
    const githubUrl = githubConnected?.connectUrl ?? '';
    if (provider === 'google' && googleUrl) {
      window.location.href = googleUrl;
    } else if (provider === 'zoom' && zoomUrl) {
      window.location.href = zoomUrl;
    } else if (provider === 'microsoft' && microsoftUrl) {
      window.location.href = microsoftUrl;
    } else if (provider === 'github' && githubUrl) {
      window.location.href = githubUrl;
    }
  };
  const handleDisconnectClick = (provider: string) => {
    if (provider === 'google') {
      googleDisconnectedReq.mutate(undefined, {
        onSuccess: () => {
          useAppConnectReq.refetch();
        },
      });
    } else if (provider === 'zoom') {
      zoomDisconnectedReq.mutate(undefined, {
        onSuccess: () => {
          useAppConnectReq.refetch();
        },
      });
    } else if (provider === 'microsoft') {
      microsoftDisconnectedReq.mutate(undefined, {
        onSuccess: () => {
          useAppConnectReq.refetch();
        },
      });
    } else if (provider === 'github') {
      githubDisconnectedReq.mutate(undefined, {
        onSuccess: (data) => {
          useAppConnectReq.refetch();
        },
        onError: (error) => {
          console.log('GitHub disconnect error in handleDisconnectClick:', error);
        },
      });
    }
  };
  const handleReconnectClick = (provider: string) => {
    if (provider === 'google') {
      googleReconnectedReq.mutate(undefined, {
        onSuccess: () => {
          useAppConnectReq.refetch();
        },
      });
    } else if (provider === 'zoom') {
      zoomReconnectedReq.mutate(undefined, {
        onSuccess: () => {
          useAppConnectReq.refetch();
        },
      });
    } else if (provider === 'microsoft') {
      microsoftReconnectedReq.mutate(undefined, {
        onSuccess: () => {
          useAppConnectReq.refetch();
        },
      });
    } else if (provider === 'github') {
      githubReconnectedReq.mutate(undefined, {
        onSuccess: () => {
          useAppConnectReq.refetch();
        },
      });
    }
  };

  const handleCardClick = (provider: string) => {
    if (provider === 'google') {
      if (googleConnected?.token && googleConnected?.tokenStatus === 'active') {
        history.push(handleCompanyUrl('/apps/google'));
      } else if (googleConnected?.token && googleConnected?.tokenStatus !== 'active') {
        googleReconnectedReq.mutate(undefined, {
          onSuccess: () => {
            useAppConnectReq.refetch();
          },
        });
      } else {
        const googleUrl = googleConnected?.googleUrl ?? '';
        if (googleUrl) {
          window.location.href = googleUrl;
        } else {
          console.error('Google URL is not available.');
        }
      }
    } else if (provider === 'zoom') {
      if (zoomConnected?.token && zoomConnected?.tokenStatus === 'active') {
        history.push(handleCompanyUrl('/apps/zoom'));
      } else if (zoomConnected?.token && zoomConnected?.tokenStatus !== 'active') {
        zoomReconnectedReq.mutate(undefined, {
          onSuccess: () => {
            useAppConnectReq.refetch();
          },
        });
      } else {
        const zoomUrl = zoomConnected?.zoomUrl ?? '';
        if (zoomUrl) {
          window.location.href = zoomUrl;
        } else {
          console.error('Zoom URL is not available.');
        }
      }
    } else if (provider === 'microsoft') {
      if (microsoftConnected?.token && microsoftConnected?.tokenStatus === 'active') {
        history.push(handleCompanyUrl('/apps/microsoft'));
      } else if (microsoftConnected?.token && microsoftConnected?.tokenStatus !== 'active') {
        microsoftReconnectedReq.mutate(undefined, {
          onSuccess: () => {
            useAppConnectReq.refetch();
          },
        });
      } else {
        const microsoftUrl = microsoftConnected?.microsoftUrl ?? '';
        if (microsoftUrl) {
          window.location.href = microsoftUrl;
        } else {
          console.error('Microsoft URL is not available.');
        }
      }
    } else if (provider === 'github') {
      if (githubConnected?.token && githubConnected?.tokenStatus === 'active') {
        history.push(handleCompanyUrl('/apps/github'));
      } else if (githubConnected?.token) {
        githubReconnectedReq.mutate(undefined, {
          onSuccess: () => {
            useAppConnectReq.refetch();
          },
        });
      } else {
        console.error('Github URL is not available.');
        const githubUrl = githubConnected?.githubUrl ?? '';
        if (githubUrl) {
          window.location.href = githubUrl;
        } else {
          console.error('Github URL is not available.');
        }
      }
    }
  };

  const mockDataPers1 = [
    { logo: GoogleSvg, provide: 'google', alt: 'google', id: googleId || null },
    { logo: ZoomSvg, provide: 'zoom', alt: 'zoom', id: zoomId || null },
    { logo: MicrosoftSvg, provide: 'microsoft', alt: 'Microsoft Entra / Office 365', id: microsoftId || null },
    { logo: GithubSvg, provide: 'github', alt: 'github', id: githubId || null },
  ];

  const handleAppSelect = (app: string) => {
    setSelectedApps((prev) => (prev.includes(app) ? prev.filter((a) => a !== app) : [...prev, app]));
  };

  const requestAppsMutation = useMutation(
    (payload: { app_names: string[] }) => axios.post(`/user/profile-requests`, payload),

    {
      onSuccess: () => {
        openNotification('success', 'Request sent successfully');
        setOpenDialog(false);
        setSelectedApps([]);
      },
      onError: () => {
        openNotification('error', 'Unable to send request');
      },
    }
  );

  const handleSubmit = () => {
    requestAppsMutation.mutate({
      app_names: selectedApps,
    });
  };

  const connectedApps = mockDataPers1.filter((app) => app.id);
  const connectedProviders = connectedApps.map((app) => app.provide);
  const remainingApps = mockDataPers1.filter((app) => !connectedProviders.includes(app.provide));

  const getCardClass = (isConnected: boolean) => {
    let className = classes.card;
    if (isConnected) {
      className += ` ${classes.approvedCard} ${classes.clickableCard}`;
    } else {
      className += ` ${classes.noAccessCard}`;
    }
    return className;
  };

  useAppPreloader(
    useAppConnectReq.isFetching ||
      googleDisconnectedReq.isLoading ||
      zoomDisconnectedReq.isLoading ||
      microsoftDisconnectedReq.isLoading ||
      githubDisconnectedReq.isLoading ||
      getUsersReq.isFetching ||
      googleReconnectedReq.isLoading ||
      zoomReconnectedReq.isLoading ||
      microsoftReconnectedReq.isLoading ||
      githubReconnectedReq.isLoading
  );
  return (
    <>
      <Grid container justify='flex-end' style={{ marginBottom: 20 }}>
        <Grid item>
          <Button variant='contained' color='primary' className={classes.btnAdd} onClick={() => setOpenDialog(true)}>
            <ControlPointIcon />
          </Button>
        </Grid>
      </Grid>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth='xs' fullWidth>
        <DialogTitle>Select Apps</DialogTitle>

        <DialogContent>
          {remainingApps.length === 0 ? (
            <Typography>No remaining apps available.</Typography>
          ) : (
            remainingApps.map((app) => (
              <FormControlLabel
                key={app.provide}
                control={
                  <Checkbox
                    checked={selectedApps.includes(app.provide)}
                    onChange={() => handleAppSelect(app.provide)}
                    color='primary'
                  />
                }
                label={app.alt.charAt(0).toUpperCase() + app.alt.slice(1)}
              />
            ))
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>

          <Button color='primary' variant='contained' disabled={selectedApps.length === 0} onClick={handleSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {permission !== 'EndUser' && profile?.permission !== 'Manager' && (
        <>
          <Container maxWidth='xl' className={classes.container}>
            <Grid className={classes.infoContainer} container alignItems='stretch' spacing={3}>
              <Grid item xs={6} sm={4} md={2}>
                <Paper className={classes.gridPaper}>
                  <p className={classes.value}>{appStatistics?.new_users_created_this_week ?? 0}</p>
                  <p className={classes.title}>
                    New Users
                    <br />
                    This Week
                  </p>
                </Paper>
              </Grid>

              <Grid item xs={6} sm={4} md={2}>
                <Paper className={classes.gridPaper}>
                  <p className={classes.value}>{appStatistics?.new_users_created_this_month ?? 0}</p>
                  <p className={classes.title}>
                    New Users
                    <br />
                    This Month
                  </p>
                </Paper>
              </Grid>

              <Grid item xs={6} sm={4} md={2}>
                <Paper className={classes.gridPaper}>
                  <p className={classes.value}>{appStatistics?.users_synced_this_week ?? 0}</p>
                  <p className={classes.title}>
                    Users Synced
                    <br />
                    This Week
                  </p>
                </Paper>
              </Grid>

              <Grid item xs={6} sm={4} md={2}>
                <Paper className={classes.gridPaper}>
                  <p className={classes.value}>{appStatistics?.users_synced_this_month ?? 0}</p>
                  <p className={classes.title}>
                    Users Synced
                    <br />
                    This Month
                  </p>
                </Paper>
              </Grid>

              <Grid item xs={6} sm={4} md={2}>
                <Paper className={classes.gridPaper}>
                  <p className={classes.value}>{appStatistics?.users_deleted_this_week ?? 0}</p>
                  <p className={classes.title}>
                    Users Deleted
                    <br />
                    This Week
                  </p>
                </Paper>
              </Grid>

              <Grid item xs={6} sm={4} md={2}>
                <Paper className={classes.gridPaper}>
                  <p className={classes.value}>{appStatistics?.users_deleted_this_month ?? 0}</p>
                  <p className={classes.title}>
                    Users Deleted
                    <br />
                    This Month
                  </p>
                </Paper>
              </Grid>
            </Grid>
          </Container>

          <h1 style={{ fontSize: '25px', fontWeight: 'bold', marginLeft: '23px' }}> Provisioned Apps</h1>
        </>
      )}
      {permission === 'EndUser' || permission === 'Manager' ? (
        !getUsersReq.isFetching ? (
          connectedApps.length > 0 ? (
            <>
              <Grid container spacing={4}>
                {connectedApps.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card className={getCardClass(true)}>
                      <CardContent>
                        <CheckCircleIcon className={`${classes.topIcon} ${classes.approvedIcon}`} />
                        <div className={classes.appRow}>
                          <img src={item.logo} alt={item.alt} className={classes.appIcon} />
                          <div>
                            <Typography className={classes.appName}>
                              {item.alt.charAt(0).toUpperCase() + item.alt.slice(1)}
                            </Typography>
                            <Typography className={classes.appDesc}>Access granted</Typography>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </>
          ) : (
            <Typography style={{ fontSize: '17px', margin: 'auto', color: '#6b7280' }}>
              Your administrator has not connected you with any third-party App
            </Typography>
          )
        ) : null
      ) : (
        <>
          <Grid container spacing={4} style={{ padding: '30px' }}>
            {mockDataPers1.map((item, index) => {
              const isConnected = Boolean(
                item.provide === 'google'
                  ? googleConnected?.token && googleConnected?.tokenStatus === 'active'
                  : item.provide === 'zoom'
                  ? zoomConnected?.token && zoomConnected?.tokenStatus === 'active'
                  : item.provide === 'microsoft'
                  ? microsoftConnected?.token && microsoftConnected?.tokenStatus === 'active'
                  : githubConnected?.token && githubConnected?.tokenStatus === 'active'
              );
              const isReConnected = Boolean(
                item.provide === 'google'
                  ? googleConnected?.token && googleConnected?.tokenStatus !== 'active'
                  : item.provide === 'zoom'
                  ? zoomConnected?.token && zoomConnected?.tokenStatus !== 'active'
                  : item.provide === 'microsoft'
                  ? microsoftConnected?.token && microsoftConnected?.tokenStatus !== 'active'
                  : githubConnected?.token
              );
              return (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    className={getCardClass(isConnected)}
                    onClick={() => {
                      handleCardClick(item.provide);
                    }}
                  >
                    <CardContent>
                      {isConnected ? (
                        <CheckCircleIcon className={`${classes.topIcon} ${classes.approvedIcon}`} />
                      ) : (
                        <RemoveCircleIcon className={`${classes.topIcon} ${classes.deniedIcon}`} />
                      )}
                      <div className={classes.appRow}>
                        <img src={item.logo} alt={item.alt} className={classes.appIcon} />
                        <div>
                          <Typography className={classes.appName}>
                            {item.alt.charAt(0).toUpperCase() + item.alt.slice(1)}
                          </Typography>
                          <Typography className={classes.appDesc}>
                            {isConnected ? 'Connected' : isReConnected ? 'Needs reconnection' : 'Available'}
                          </Typography>
                        </div>
                      </div>

                      <div style={{ position: 'absolute', bottom: '16px', right: '16px' }}>
                        {!isConnected && (
                          <Button
                            variant='outlined'
                            size='small'
                            className={classes.requestBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (isReConnected) {
                                handleReconnectClick(item.provide);
                              } else {
                                handleConnectClick(item.provide);
                              }
                            }}
                          >
                            {isReConnected ? 'Reconnect' : 'Connect'}
                          </Button>
                        )}
                        {isConnected && (
                          <Button
                            variant='outlined'
                            size='small'
                            className={classes.requestBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDisconnectClick(item.provide);
                            }}
                          >
                            Disconnect
                          </Button>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
    </>
  );
});
